module.exports = __webpack_public_path__ + "dist/assets/img/connect_illus.757ccc1c.svg";